import React from 'react';

function UsageBar({ label, used, limit }) {
  const unlimited = limit === null || limit === undefined;
  const pct = unlimited ? 0 : Math.min(100, Math.round(((used || 0) / Math.max(limit, 1)) * 100));
  const atLimit = !unlimited && used >= limit;
  return (
    <div>
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm text-gray-600">{label}</span>
        <span className={`text-sm font-medium ${atLimit ? 'text-red-600' : 'text-gray-900'}`}>
          {unlimited ? `${used ?? 0} / ∞` : `${used ?? 0} / ${limit}`}
        </span>
      </div>
      {!unlimited && (
        <div className="w-full h-2 bg-gray-100 rounded-full overflow-hidden">
          <div
            className={`h-full rounded-full ${atLimit ? 'bg-red-500' : 'bg-purple-500'}`}
            style={{ width: `${pct}%` }}
          />
        </div>
      )}
    </div>
  );
}

export default function AccountUsageCard({ usage, loading }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Account Usage</h2>
        <p className="text-sm text-gray-500">Your current plan limits and today's usage.</p>
      </div>

      {loading || !usage ? (
        <div className="text-center py-8 text-gray-500 text-sm">Loading…</div>
      ) : (
        <>
          {!usage.is_unlimited && usage.trial_days_remaining !== null && (
            <div className={`mb-6 p-4 rounded-xl border ${usage.trial_days_remaining <= 0 ? 'bg-red-50 border-red-200' : 'bg-purple-50 border-purple-200'}`}>
              {usage.trial_days_remaining <= 0 ? (
                <p className="text-sm text-red-700 font-medium">Your trial has expired. Please upgrade your plan to continue.</p>
              ) : (
                <p className="text-sm text-purple-700 font-medium">
                  {usage.trial_days_remaining} day{usage.trial_days_remaining === 1 ? '' : 's'} left in your trial
                </p>
              )}
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5">
            <UsageBar label="Articles today" used={usage.articles_today} limit={usage.articles_limit} />
            <UsageBar label="Pinterest accounts" used={usage.pinterest_count} limit={usage.pinterest_limit} />
            <UsageBar label="Facebook pages" used={usage.facebook_count} limit={usage.facebook_limit} />
            <UsageBar label="Threads accounts" used={usage.threads_count} limit={usage.threads_limit} />
            <UsageBar label="Etsy accounts" used={usage.etsy_count} limit={usage.etsy_limit} />
          </div>
        </>
      )}
    </div>
  );
}
